import { checkElementInView } from "../../../js/src/__utils/checkElementInView";

const animationSelectors = '.block-scroll-carousel__card';
const sections = document.querySelectorAll(animationSelectors);

const showSection = (e) => {
	e.classList.add('in-viewport');
};

const hideSection = (e) => {
	e.classList.remove('in-viewport');
};

const sectionsInView = () => {
	if (sections.length) {
		checkElementInView(animationSelectors, showSection, hideSection, {
			root: null,
			rootMargin: "-272px 0px -128px 0px",
			threshold: [0],
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		sectionsInView();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
